import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
import { EventInterface } from '@splidejs/splide';

// Homepage hero slider
if(document.querySelector('.hero-slider')) {
	const heroSlider = new Splide('.hero-slider', {
		type: 'fade',
		interval: 5000,
		arrows: false,
		autoplay: true,
		pauseOnHover: false,
		pauseOnFocus: false,
		speed: 800,
		rewind: true,
	}).mount();
	let heroTimeout;

	heroSlider.on('move', function(newIndex, prevIndex){
		jQuery('.hero-slider .splide__slide').removeClass('previously-active');
		jQuery('.hero-slider .splide__slide').eq(prevIndex).addClass('previously-active');

		clearTimeout(heroTimeout);
		heroTimeout = setTimeout(function() {
			jQuery('.hero-slider .splide__slide').eq(prevIndex).removeClass('previously-active');
		}, 800);
	});

	heroSlider.on('active', function(Slide){
		let theVid = Slide.slide.querySelector('video');
		if(theVid) {
			theVid.play();
		}
	});
	heroSlider.on('inactive', function(Slide){
		let theVid = Slide.slide.querySelector('video');
		if(theVid) {
			theVid.pause();
		}
	});
}

if(document.querySelector('.logo-slider')) {
	const logoSlider = new Splide('.logo-slider', {
		type: 'loop',
		drag: 'free',
		arrows: false,
		pagination: false,
		autoWidth: true,
		autoScroll: {
			speed: 1,
		},
		breakpoints: {
			767: {
				destroy: true,
			}
		}
	}).mount({ AutoScroll });
}


function MyTransition( Splide, Components ) {
	const { bind } = EventInterface( Splide );
	const { Move } = Components;
	const { list } = Components.Elements;
	let endCallback;
	let lastIndex = 0;

	function mount() {
		bind( list, 'transitionend', e => {
			if ( e.target === list && endCallback ) {
				// Removes the transition property
				cancel();

				// Calls the `done` callback
				endCallback();
			}
		} );
	}

	function start( index, done ) {
		// Converts the index to the position

		const destination = Move.toPosition( index, true );

		// Applies the CSS transition
		list.style.transition = 'transform 300ms linear';

		// Moves the carousel to the destination.
		if(lastIndex < index) {
			Move.translate( destination + 440 );

		} else {
			Move.translate( destination );
		}

		lastIndex = index;

		// Keeps the callback to invoke later.
		endCallback = done;
	}

	function cancel() {
		list.style.transition = '';
	}

	return {
		mount,
		start,
		cancel,
	};
}

const historyCarousel = document.querySelectorAll('.history-carousel');
historyCarousel.forEach(elm => {
	const heroSlider = new Splide(elm, {
		type: 'slide',
		arrows: false,
		pagination: false,
		autoWidth: true,
		updateOnMove: true,
		cloneStatus: false,
		speed: 300,
		drag: false,
		easing: 'linear',
		trimSpace: false,
		breakpoints: {
			1199: {
				drag: 'free',
			}
		}
	});

	heroSlider.on("click", function (slide) { // listen for "click" event: fired when the user clicks any slide
	  heroSlider.go(slide.index); // apply "go" method: slide to the index of the clicked slide (component)
	});

	var years = elm.getElementsByClassName( 'carousel-nav-btn' );
	var current;

	for ( var i = 0; i < years.length; i++ ) {
		initYears( years[ i ], i );
	}

	function initYears( year, index ) {
		year.addEventListener( 'click', function () {
		heroSlider.go( index );
	} );
	}

	heroSlider.on( 'mounted move', function () {
	var year = years[ heroSlider.index ];

	if ( year ) {
		if ( current ) {
			current.classList.remove( 'is-active' );
		}

		year.classList.add( 'is-active' );
		current = year;
		}
	} );

	heroSlider.mount({}, MyTransition);

});

jQuery(function($){
	$('form.cart').on( 'click', 'button.plus, button.minus', function() {
		var qty = $( this ).closest( 'form.cart' ).find( '.qty' );
		var val   = parseFloat(qty.val());
		var max = parseFloat(qty.attr( 'max' ));
		var min = parseFloat(qty.attr( 'min' ));
		var step = parseFloat(qty.attr( 'step' ));
		if ( $( this ).is( '.plus' ) ) {
			if ( max && ( max <= val ) ) {
				qty.val( max );
			} else {
				qty.val( val + step );
			}
		} else {
			if ( min && ( min >= val ) ) {
				qty.val( min );
			} else if ( val > 1 ) {
				qty.val( val - step );
			}
		}
	});

	// Set focus to keyword field if search modal is shown
	$('#search-modal').on('shown.bs.modal', function(){
		$(this).find('.search-keyword').focus();
	});

	// Mega menu
	let menuTimeout;
	$('.primary-menu > li').on('mouseenter', function(){
		let megaMenu = $(this).find('> .mega-menu');
		clearTimeout(menuTimeout);
		$('.mega-menu').removeClass('mm-active');
		megaMenu.addClass('mm-active');
	}).on('mouseleave', function(){
		menuTimeout = setTimeout(function(){
			$('.mega-menu').removeClass('mm-active');
		}, 300);
	});
	$('.header-menu').on('mouseenter', function(){
		$('.mega-menu').removeClass('mm-active');
	});


	// Mobile menu
	$('.mobile-nav-toggle').on('click', function(e){
		e.preventDefault();
		$('#page').addClass('mnav-expanded');
	});
	$('.mnav-close-button, .mobile-nav-before').on('click', closeMobileMenu);
	$('.mnav-subnav-toggle').on('click', function(e){
		e.preventDefault();
		if($(this).closest('li').hasClass('border')) {
			$(this).siblings('.borderlink-submenu').slideToggle(300).toggleClass('expanded');
		} else {
			$(this).siblings('.mnav-submenu').addClass('expanded');
		}
	});
	$('.mnav-back-button').on('click', function(e){
		e.preventDefault();
		$(this).closest('.mnav-submenu').removeClass('expanded');
	});
	$('.mnav-header .nav-arrow').on('click', function(e){
		e.preventDefault();
		$(this).closest('li').toggleClass('expanded');
	});
	function closeMobileMenu() {
		$('.mnav-submenu, .mnav-header li').removeClass('expanded');
		$('#page').removeClass('mnav-expanded');
		$('.mnav-inner').scrollTop(0);
		$('#mobile-nav li.border .borderlink-submenu').hide();
	}
});
